"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIATALocations = getIATALocations;
var _config = _interopRequireDefault(require("../../../consts/config"));
function sanitizeApiResponse(location) {
  return {
    locationId: location.id,
    city: sanitizeLocationArea(location.city),
    country: location.type === "airport" || location.type === "station" ? sanitizeLocationArea(location.city.country) : sanitizeLocationArea(location.country)
  };
}
function sanitizeLocationArea(area) {
  return area ? {
    locationId: area.id,
    name: area.name
  } : null;
}
async function getIATALocations(value, locale = "en-US") {
  var _response$locations;
  const response = await fetch(`${_config.default.apiLocations}?term=${value}&locale=${locale}&location_types=airport`).then(res => res.json());
  const sanitizedResponse = (_response$locations = response.locations) === null || _response$locations === void 0 ? void 0 : _response$locations.map(location => sanitizeApiResponse(location));
  return sanitizedResponse;
}